<template>
  <!-- Navigation Start -->
  <div class="border-b border-gray-800">
    <nav class="container mx-auto flex flex-col lg:flex-row items-center justify-between py-6 px-4">
      <div class="flex flex-col lg:flex-row items-center">
        <router-link class="" :to="{name: 'home'}">
          <p class="font-semibold tracking-wide logo-title">
            <span class="text-orange-500 text-3xl">Crystal</span>
            <span class="text-blue-500">Movie</span>
          </p>
        </router-link>
        <ul class="flex ml-0 lg:ml-16 space-x-4 md:space-x-8 mt-6 lg:mt-0">
          <li>
            <router-link :to="{name: 'home'}" class="hover:text-gray-400">Movies</router-link>
          </li>
          <li>
            <router-link :to="{name: 'tvShows'}" class="hover:text-gray-400">TV Shows</router-link>
          </li>
          <li>
            <router-link :to="{name: 'actors'}" class="hover:text-gray-400">Actors</router-link>
          </li>
          <li>
            <router-link :to="{name: 'coming'}" class="hover:text-gray-400">Coming Soon</router-link>
          </li>
        </ul>
      </div>
      <div class="flex items-center mt-6 lg:mt-0">
        <div class="relative">
          <input type="text"
                 class="bg-gray-800
                                focus:outline-none
                                rounded-full text-sm
                                px-3 py-2 w-64 pl-8"
                 v-model="search"
                 @keyup.enter="callApi(search)"
                 placeholder="Search...."
          >
          <div class="absolute top-0 flex items-center ml-2 h-full">
            <div class="fill-current text-gray-400 w-4">
              <i class="fa-solid fa-search"></i>
            </div>
          </div>
          <div class="absolute top-0 mt-2 mr-2 right-0"
               v-if=" search.length > 0 && searchResults.length < 1">
            <div style="border-top-color:transparent"
                 class="w-4 h-4 border-2 border-blue-400 border-solid rounded-full animate-spin">
            </div>
          </div>
          <div class="absolute bg-gray-800 text-sm rounded w-64 h-96 overflow-y-scroll mt-2 z-50"
               v-if="search.length > 0 && searchResults.length > 0">
            <ul>
              <template v-if="searchResults.length > 0 && !notFound">
                <li class="border-b border-gray-700" @click="clearSearch"
                    v-for="searchResult in searchResults" :key="searchResult.id">
                  <router-link :to="{name: 'detail', params: {id: searchResult.id}}"
                               class="p-3 hover:bg-gray-700 flex items-center">
                    <img :src="imagePath(searchResult.poster_path)" alt="search image" class="w-8">
                    <span class="ml-4">
                      {{ searchResult.title }}
                    </span>
                  </router-link>
                </li>
              </template>
              <li class="border-b border-gray-700 p-3 flex items-center" v-else>
                Not Found For {{ search }}
              </li>
            </ul>
          </div>
        </div>
        <!-- <div class="ml-6">
          <img src="../assets/images/user.png" alt="login-user"
               class="w-10 rounded-full border-2 border-gray-600 p-1">
        </div> -->
      </div>
    </nav>
  </div>
  <!-- Navigation End -->
</template>

<script>
import axios from "axios";

export default {
  name: "NavigationBar",
  data() {
    return {
      search: "",
      searchResults: [],
      notFound: false,
    }
  },
  computed: {
    clearSearch() {
       this.search = '';
       this.searchResults = [];
    }
  },
  methods: {
    callApi(search) {
      let token= 'eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI5Y2Q5ZDIzMWMyZWNmOWVlMjMwNTQ1MjY2MDA0NGU1YSIsInN1YiI6IjYyYWMxOGNiZDdjZDA2MDA5Mjk5ZTNiYSIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.8aPeoTYZyUOuN72OyZbXh7gDcw6-RhwVJ4vIedUaeFo';
      axios.get(`https://api.themoviedb.org/3/search/movie?query=${search}`,{
        headers: {"Authorization" : `Bearer ${token}`}
      })
      .then(res => {
        if (res.data.results.length > 0){
          this.searchResults = res.data.results;
          this.notFound = false;
        }else {
          this.notFound = true;
        }
      })
      .catch(error => console.log(error));
    },

    imagePath(image) {
      if (image){
        return  'https://image.tmdb.org/t/p/w92/'+image;
      }else {
        return 'https://via.placeholder.com/50x75';
      }
    },

  },
}
</script>

<style scoped>

</style>